import { render, staticRenderFns } from "./Financials.vue?vue&type=template&id=795db1b1&scoped=true&"
import script from "./Financials.vue?vue&type=script&lang=js&"
export * from "./Financials.vue?vue&type=script&lang=js&"
import style0 from "./Financials.vue?vue&type=style&index=0&id=795db1b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795db1b1",
  null
  
)

export default component.exports